import { ICameraPermissionLabelSetting, ICommonSettings, ILanguageModel } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { IWithSDProps } from "../../../../../shared/hoc/screen-design-consumer";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigCameraSettings } from "./app-settings-config-camera";

export interface IConfigCameraInputState {
  showModal: boolean;
  editingCameraId: string;
}

export interface IConfigCameraInputProps {
  parentData: string;
  commonSettings: ICommonSettings;
  languages: ILanguageModel[];
  getSectionDescription: (contentKey: string) => ReactNode;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigCameraInput extends PureComponent<IConfigCameraInputProps, IConfigCameraInputState> {
  formInputName = ["", "cameraPermissionLabelSettingsId"];

  constructor(props: IConfigCameraInputProps & IWithSDProps) {
    super(props);
    this.formInputName[0] = props.parentData;
    this.state = {
      showModal: false,
      editingCameraId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingCameraId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingCamera = (id: string) => {
    this.setState({ editingCameraId: id, showModal: true });
  };

  render() {
    const options = [
      { id: null, name: "Default" } as unknown as ICameraPermissionLabelSetting,
      ...(this.props.commonSettings.cameraPermissionLabelSettings || [])
    ];

    return (
      <>
        <ConfigCameraSettings
          formInputName={this.formInputName}
          showModal={this.state.showModal}
          closeModal={() => {
            this.closeModal();
          }}
          editingCameraId={this.state.editingCameraId}
          languages={this.props.languages}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Configuration"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey={
            this.props.parentData === "androidConfig" ? "android_camera_description" : "ios_camera_permissiontext"
          }
          onAddNew={this.openModal}
          onEdit={this.setEditingCamera}
          dropdownTestId={`${this.props.parentData === "androidConfig" ? "android" : "ios"}CameraConfigDropdown`}
          addNewTestId={`${
            this.props.parentData === "androidConfig" ? "android_camera_description" : "ios_camera_permissiontext"
          }AddNewButton`}
          editTestId={`${
            this.props.parentData === "androidConfig" ? "android_camera_description" : "ios_camera_permissiontext"
          }EditButton`}
        />
      </>
    );
  }
}
